import BulkUploadList from "@/pages/transporter/bulk-upload/BulkUploadList.vue"
import BulkUploadDetails from "@/pages/transporter/bulk-upload/BulkUploadDetails.vue"
import Blank from "@/layouts/blank.vue"

const bulkUploadRoutes = [
    {
        path: "bulk-upload",
        name: "app-transporter-bulk-upload",
        component: Blank,
        children: [
            {
                path: "/",
                redirect: "/app/transporter/bulk-upload/list",
            },
            {
                path: "list",
                name: "app-transporter-bulk-upload-list",
                component: BulkUploadList,
            },
            {
                path: "details/:id",
                name: "app-transporter-bulk-upload-details",
                component: BulkUploadDetails,
            },
        ]
    },
]

export default bulkUploadRoutes
